import React from "react";
import { Navigate } from "react-router-dom";
import { ModuleConfig } from "../../types/ModuleConfig";

// Lazy-load pages
const ChaseDashboard = React.lazy(() => import("./pages/ChaseDashboard"));
const ChaseConfigList = React.lazy(() => import("./pages/ChaseConfigList"));
const ChaseConfigForm = React.lazy(() => import("./pages/ChaseConfigForm"));
const ChaseHistory = React.lazy(() => import("./pages/ChaseHistory"));
const NotificationRules = React.lazy(() => import("./pages/NotificationRules"));

// Legacy /tom-manager/* URLs redirect to /client-journey/*
const RedirectToRoot = () => React.createElement(Navigate, { to: "/client-journey", replace: true });
const RedirectToConfigs = () => React.createElement(Navigate, { to: "/client-journey/configs", replace: true });
const RedirectToHistory = () => React.createElement(Navigate, { to: "/client-journey/history", replace: true });

const clientJourneyModuleConfig: ModuleConfig = {
  id: "client-journey",
  name: "Client Journey Cockpit",
  description: "Daily cockpit for chasing clients through onboarding journeys — draft emails + SMS, review & send",
  version: "2.0.0",
  enabled: true,
  category: "intelligence",
  order: 98,
  icon: "🧭",
  color: "#9F7AEA",

  routes: [
    // New canonical URLs
    { path: "/client-journey", component: ChaseDashboard, permissionLevel: "view", useLayout: true },
    { path: "/client-journey/configs", component: ChaseConfigList, permissionLevel: "view", useLayout: true },
    { path: "/client-journey/configs/new", component: ChaseConfigForm, permissionLevel: "create", useLayout: true },
    { path: "/client-journey/configs/:id/edit", component: ChaseConfigForm, permissionLevel: "edit", useLayout: true },
    { path: "/client-journey/history", component: ChaseHistory, permissionLevel: "view", useLayout: true },
    { path: "/client-journey/notifications", component: NotificationRules, permissionLevel: "edit", useLayout: true },

    // Legacy /tom-manager URLs → redirect to /client-journey
    { path: "/tom-manager", component: RedirectToRoot, permissionLevel: "view" },
    { path: "/tom-manager/configs", component: RedirectToConfigs, permissionLevel: "view" },
    { path: "/tom-manager/configs/new", component: RedirectToConfigs, permissionLevel: "view" },
    { path: "/tom-manager/configs/:id/edit", component: RedirectToConfigs, permissionLevel: "view" },
    { path: "/tom-manager/history", component: RedirectToHistory, permissionLevel: "view" },
  ],

  navigation: [
    { label: "Today's Cockpit", path: "/client-journey", icon: "🧭", permissionLevel: "view" },
    { label: "Tracked Clients", path: "/client-journey/configs", icon: "👥", permissionLevel: "view" },
    { label: "Add Client", path: "/client-journey/configs/new", icon: "➕", permissionLevel: "create" },
    { label: "History", path: "/client-journey/history", icon: "📜", permissionLevel: "view" },
    { label: "Notification Rules", path: "/client-journey/notifications", icon: "🔔", permissionLevel: "edit" },
  ],

  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
  },
};

export default clientJourneyModuleConfig;
